import BaseRequest from './BaseRequest';

export default class CollectionRequest extends BaseRequest {
  getList(params = {}) {
    const url = `/public/collections`;
    return this.get(url, params);
  }

  getAssets(params = {}) {
    const url = `/my/items`;
    return this.get(url, params);
  }
}
